function initState() {
  return {}
}

const state = initState()

const mutations = {}

const actions = {
  async VALIDATE_EMAIL(_, { email }) {
    try {
      const response = await this.$customApiService().post(
        `/payment/validate/email`,
        {
          email,
        }
      )
      return {
        success: true,
        data: response,
      }
    } catch (error) {
      console.error('VALIDATE_EMAIL:', error)
      return {
        success: false,
        errorCode:
          error.response?.data?.code ||
          error.response?.data?.message ||
          error.response?.data,
        errorData: error.response?.data,
      }
    }
  },

  async PENDING_EMAIL(_, { rec_email, coin_id, amount }) {
    try {
      await this.$customApiService().post(`payment/email/external`, {
        rec_email,
        coin_id,
        amount,
      })
      return {
        success: true,
      }
    } catch (error) {
      console.error('PENDING_EMAIL:', error)
      return {
        success: false,
        errorCode:
          error.response?.data?.code ||
          error.response?.data?.message ||
          error.response?.data,
      }
    }
  },

  async WITHDRAW_TO_EMAIL(_, { rec_email, coin_id, amount }) {
    try {
      const response = await this.$customApiService().post(`/payment/email`, {
        rec_email,
        coin_id,
        amount,
      })
      return {
        success: true,
        data: response,
      }
    } catch (error) {
      console.error('WITHDRAW_TO_EMAIL:', error)
      return {
        success: false,
        errorCode:
          error.response?.data?.code ||
          error.response?.data?.message ||
          error.response?.data,
      }
    }
  },

  async EMAIL_PAYMENT_HISTORY() {
    try {
      const { id_list } = await this.$customApiService().get(`/payment/history`)

      return {
        success: true,
        data: id_list ?? [],
      }
    } catch (error) {
      console.error('GET_PAYMENT_HISTORY:', error)

      return {
        success: false,
        errorCode:
          error.response?.data?.code ||
          error.response?.data?.message ||
          error.response?.data,
        data: [],
      }
    }
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
